jQuery(function ($) {
    let $form = $('form#contact-form');
    $('.validation.error', $form).each(function () {
        $('html, body').animate({ scrollTop: $(this).offset().top}, 1000);
        return false;
    });
    grecaptcha.ready(function () {
        grecaptcha.execute(currentEnvironment.gCaptchaSitekey, {action: 'contact'}).then(function (token) {
            $('input[name = "token"]', $form).val(token);
        });
    });

});
